import api from '@/lib/api'

const state = () => ({
  all: [],

  currentUser: {
    user_id: -1,
    name: '',
    display_name: '',
    email: '',
    role: '',
    last_login: null,
    logged_in: false,
  },

  currentUserRequests: [],
})

const getters = {
  all:  state => state.all,
  currentUser: state => state.currentUser,
  currentUserRequests: state => state.currentUserRequests,
}

const actions = { 
  async createUser({ dispatch, rootGetters }, user ) {
    const result = await api.post('/users/', { user })
    if (result.ok) {
      dispatch('loadAll', rootGetters['filters/usersFilters'])
      return { ok: true, created: await result.json() }
    } 
 
    return { ...await result.json(), status: result.status, ok: false }
  },

  // eslint-disable-next-line no-empty-pattern
  async deleteUser({ }, { user_id } ) {
    const result = await api.delete(`/users/${ user_id }`)
    if (result.ok) {
      return { ok: true }
    } 
 
    return { ...await result.json(), status: result.status, ok: false }
  },

  async loadAll({ commit }, { inactive }) {
    let params = new URLSearchParams()
    if ( inactive != null) params.append('inactive', inactive)

    const result = await api.get('/users' + (params == '' ? params : '?' + params))
    if (result.ok) {
      commit('SET_ALL', await result.json())
      return { ok: true }
    } 
 
    return { ...await result.json(), status: result.status, ok: false }
  },

  async loadCurrentUser({ commit }, { user_id }) {
    const result = await api.get(`/users/${ user_id }`)
    if (result.ok) {
      commit('SET_CURRENT_USER', await result.json())
      return { ok: true }
    } 
 
    return { ...await result.json(), status: result.status, ok: false }
  },

  async updateCurrentUser({ commit }, { user_id, ...user } ) {
    const result = await api.put(`/users/${ user_id }`, { user })
    if (result.ok) {
      const updated = await result.json()
      commit('SET_CURRENT_USER', updated)
      return { ok: true, updated }
    } 
 
    return { ...await result.json(), status: result.status, ok: false }
  },

  async loadCurrentUserRequests({ commit }, { user_id }) {
    const result = await api.get(`/users/${ user_id }/requests`)

    if (result.ok) {
      const referrals = await result.json()
      commit('SET_CURRENT_USER_REFERRALS', referrals)
      return { ok: true }
    } 
 
    return { ...await result.json(), status: result.status, ok: false }
  },

  // eslint-disable-next-line no-empty-pattern
  async activateUser({ }, { user_id } ) {
    const result = await api.put(`/users/${ user_id }`, { active: true })
    if (result.ok) {
      const updated = await result.json()
      return { ok: true, updated }
    } 
 
    return { ...await result.json(), status: result.status, ok: false }
  },

  // eslint-disable-next-line no-empty-pattern
  async sendReminder({ }, { user_id } ) {
    const result = await api.put(`/users/${ user_id }/send_reminder`, { active: true })
    if (result.ok) {
      return { ok: true }
    } 
 
    return { ...await result.json(), status: result.status, ok: false }
  },
}

const mutations = { 
  SET_ALL: (state, users) => state.all = users,
  SET_CURRENT_USER: (state, user) => state.currentUser = user,
  SET_CURRENT_USER_REFERRALS: (state, referrals) => state.currentUserRequests = referrals,
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}